module.exports = __webpack_public_path__ + "static/media/vf_wpants_core.20d04d5e.svg";